var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,6c-0.708984,0 -1.3999,-0.149902 -2.05371,-0.445312c-0.378418,-0.171387 -0.824707,-0.0898438 -1.11914,0.204102l-2.34961,2.34961c-0.293457,-0.228516 -0.574219,-0.477051 -0.841797,-0.744141c-0.26709,-0.26709 -0.515137,-0.54834 -0.744141,-0.841797l2.34961,-2.34961c0.294434,-0.293945 0.375488,-0.739746 0.204102,-1.11914c-0.29541,-0.653809 -0.445313,-1.34473 -0.445313,-2.05371c0,-0.552246 -0.447754,-1 -1,-1h-4c-0.552246,0 -1,0.447754 -1,1c0,2.93799 1.14404,5.7002 3.22168,7.77832c2.07812,2.07764 4.84033,3.22168 7.77832,3.22168c0.552246,0 1,-0.447754 1,-1v-4c0,-0.552246 -0.447754,-1 -1,-1Z",
    transform: "translate(1 3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5,6l3.5,-3l-3.5,-3v2h-3.5v2h3.5Z",
    transform: "translate(8 1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardCall);
export default __webpack_public_path__ + "static/media/forward-call.8c3e9581.svg";
export { ForwardRef as ReactComponent };